import {CONSTANTS} from '../constants/constants';
import {HttpMethod, httpClient} from './httpClient';

export const getProfileImage = (): Promise<any> => {
  return httpClient('/me/photo/$value', HttpMethod.Get, null, CONSTANTS.SERVICE_TYPES.MSGRAPH);
}